import { ActionTree } from "vuex";
import { IStoreRootState } from "@/store/interface";
import { ForexDraftAction, ForexDraftGetter, ForexDraftMutation } from "@/feature/Forex/store/draft/constants";
import { $deleteForexDraft, $getForexDraftListOnce } from "@/feature/Forex/api/draft/forex-draft";
import { ForexDraftState } from "@/feature/Forex/store/draft/interface";
import { getDraftFilter, getDraftNextPageFilters } from "@/feature/Forex/store/draft/utils";
import { nextPageIsAvailable } from "@/feature/Forex/store/utils";

export default <ActionTree<ForexDraftState, IStoreRootState>> {

	async [ForexDraftAction.loadDraftNextPage](context) {
		if (!nextPageIsAvailable(context, ForexDraftGetter.loading))
			return [];

		return context.dispatch(
			ForexDraftAction.loadPage,
			getDraftNextPageFilters(context.state, context.commit)
		);
	},

	async [ForexDraftAction.loadPage]({ state, commit }) {
		commit(ForexDraftMutation.setDraftLoading, true);

		const list = await $getForexDraftListOnce(getDraftFilter(state));

		commit(ForexDraftMutation.addDraftList, list);
		commit(ForexDraftMutation.setDraftLoading, false);

		if (list.length < state.pageSize)
			commit(ForexDraftMutation.setIsEndPage, true);

		return list;
	},

	async [ForexDraftAction.reloadPage]({ state, commit, dispatch }) {
		commit(ForexDraftMutation.resetPage);

		return dispatch(ForexDraftAction.loadPage, getDraftFilter(state));
	},

	async [ForexDraftAction.fetchDeleteDraft]({ commit }, draftId: number) {
		const status = await $deleteForexDraft(draftId);

		if (status) commit(ForexDraftMutation.deleteDraft, draftId);

		return status;
	},

}